function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSymbolLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "525px",
    height: "396px",
    viewBox: "0 0 131 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.019608%,43.921569%,59.607843%)",
      fillOpacity: 1
    },
    d: "M 27.695312 5.5 L 27.945312 6 L 29.691406 5.75 L 35.183594 5.75 L 35.683594 6 L 35.929688 5.5 L 35.929688 6 L 37.679688 5.75 L 43.167969 5.75 L 43.667969 6 L 43.917969 5.5 L 43.917969 6 L 45.664062 5.75 L 51.152344 5.75 L 51.652344 6 L 51.902344 5.5 L 51.902344 6 L 53.648438 5.75 L 59.136719 5.75 L 59.636719 6 L 59.886719 5.5 L 59.886719 6 L 61.632812 5.75 L 67.121094 5.75 L 67.621094 6 L 67.871094 5.5 L 67.871094 6 L 69.617188 5.75 L 75.105469 5.75 L 75.605469 6 L 75.855469 5.5 L 75.855469 6 L 77.601562 5.75 L 83.089844 5.75 L 83.589844 6 L 83.839844 5.5 L 83.839844 6 L 85.585938 5.75 L 91.078125 5.75 L 91.574219 6 L 91.824219 5.5 L 91.824219 6 L 93.570312 5.75 L 99.0625 5.75 L 99.558594 6 L 99.808594 5.5 L 99.808594 6 L 101.554688 5.75 L 107.046875 5.75 L 107.542969 6 L 107.792969 5.5 L 107.792969 6 L 109.539062 5.75 L 110.289062 5.75 L 111.039062 8.75 L 110.789062 11.75 L 110.789062 19.75 L 111.039062 21 L 110.789062 22.25 L 110.789062 27.75 L 109.789062 29 L 107.542969 29.25 L 107.296875 29 L 103.550781 28.75 L 103.054688 27 L 103.054688 15.75 L 103.304688 15.25 L 103.304688 13.75 L 101.554688 14 L 30.191406 14 L 30.191406 26.75 L 29.941406 28.5 L 29.195312 29.25 L 27.695312 29.25 L 26.199219 29 L 23.953125 29 L 22.707031 28.75 L 22.207031 27.25 L 22.207031 8.75 L 22.707031 6.25 L 24.453125 5.75 L 27.199219 5.75 L 27.695312 6 Z M 27.695312 5.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(6.27451%,29.411765%,47.843137%)",
      fillOpacity: 1
    },
    d: "M 108.542969 72.5 L 108.792969 73.25 L 109.789062 73 L 110.789062 73.75 L 110.789062 91.75 L 110.289062 94 L 108.542969 94.25 L 106.796875 94 L 103.800781 94.25 L 102.804688 94 L 100.558594 94.25 L 28.695312 94.25 L 23.207031 94 L 22.457031 93.25 L 22.207031 91.25 L 22.207031 75.25 L 22.457031 73.5 L 28.695312 73.5 L 28.945312 86.5 L 33.933594 86.5 L 35.183594 86.25 L 36.429688 86.25 L 36.929688 86 L 40.171875 86 L 42.667969 86.25 L 44.914062 86 L 84.839844 86 L 86.085938 86.25 L 92.824219 86.25 L 96.066406 86 L 100.808594 86 L 103.304688 86.25 L 103.054688 84.5 L 103.054688 75 L 103.550781 73.75 L 103.800781 73.25 L 104.550781 73 L 108.042969 73 L 108.542969 73.25 Z M 108.542969 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.372549%,50.588235%,63.921569%)",
      fillOpacity: 1
    },
    d: "M 70.367188 26.25 L 86.585938 26.25 L 86.585938 26.75 L 87.332031 27 L 89.828125 30.5 L 114.53125 30.5 L 114.53125 31 L 115.53125 30.75 L 116.777344 32.25 L 117.027344 33.5 L 116.277344 35 L 114.53125 36 L 111.539062 36 L 110.039062 35.75 L 107.046875 35.75 L 106.546875 36 L 90.578125 36 L 89.078125 35.75 L 79.347656 35.75 L 77.851562 34.75 L 75.605469 31.75 L 74.359375 31.5 L 74.359375 31 L 73.609375 31 L 73.359375 31.5 L 72.363281 31.75 L 72.363281 31.25 L 68.121094 31.5 L 64.875 31.5 L 64.378906 31.75 L 64.378906 31.25 L 60.136719 31.5 L 56.890625 31.5 L 56.390625 31.75 L 56.390625 31.25 L 54.148438 31.25 L 52.898438 31.5 L 52.152344 33 L 50.652344 35 L 49.65625 35.75 L 37.179688 35.75 L 36.679688 36 L 28.695312 36 L 26.199219 35.75 L 17.21875 35.75 L 15.71875 34.5 L 15.46875 33.25 L 16.21875 31.5 L 17.464844 30.75 L 18.714844 30.5 L 39.921875 30.5 L 41.171875 30.75 L 41.671875 30.5 L 41.921875 29.75 L 42.417969 29.75 L 42.417969 29.25 L 42.917969 29.25 L 43.417969 28 L 44.664062 26.75 L 46.160156 26.5 L 69.867188 26.5 Z M 70.367188 26.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.196078%,40%,57.254902%)",
      fillOpacity: 1
    },
    d: "M 19.214844 65.25 L 19.460938 65.75 L 22.957031 65.5 L 23.703125 65.75 L 23.953125 65.25 L 23.953125 65.75 L 26.199219 65.5 L 27.449219 65.25 L 52.398438 65.25 L 55.644531 65.75 L 55.894531 65.25 L 55.894531 65.75 L 59.136719 65.75 L 59.386719 65.25 L 59.386719 65.75 L 62.878906 65.5 L 63.628906 65.75 L 63.878906 65.25 L 63.878906 65.75 L 67.121094 65.75 L 67.371094 65.25 L 67.371094 65.75 L 70.863281 65.5 L 71.613281 65.75 L 71.863281 65.25 L 71.863281 65.75 L 75.105469 65.75 L 75.355469 65.25 L 75.355469 65.75 L 79.847656 65.25 L 79.847656 65.75 L 83.089844 65.75 L 83.339844 65.25 L 83.339844 65.75 L 86.835938 65.5 L 87.582031 65.75 L 87.832031 65.25 L 87.832031 65.75 L 91.078125 65.75 L 91.324219 65.25 L 91.324219 65.75 L 92.074219 65.75 L 92.324219 65.25 L 108.292969 65.25 L 111.539062 65.75 L 111.785156 65.25 L 111.785156 65.75 L 115.03125 65.75 L 115.28125 65.25 L 115.28125 65.75 L 116.527344 66.25 L 117.277344 67.5 L 116.777344 68.75 L 115.777344 70 L 115.03125 70 L 114.78125 70.5 L 83.339844 70.5 L 82.34375 70.75 L 55.644531 70.75 L 51.652344 70.5 L 25.203125 70.5 L 23.703125 70.75 L 22.457031 70.5 L 18.964844 70.5 L 16.46875 70 L 15.71875 69.25 L 15.71875 68.75 L 15.222656 68.5 L 15.96875 66.25 L 16.71875 65.75 L 19.214844 65.75 Z M 19.214844 65.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,32.156863%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 62.628906 35.5 L 66.375 35.5 L 68.121094 36 L 71.113281 37 L 72.613281 37.75 L 72.613281 38.25 L 73.859375 38.75 L 75.105469 40 L 75.855469 40.25 L 76.851562 42.25 L 77.351562 42.75 L 77.851562 44.25 L 78.351562 44.5 L 79.097656 47.5 L 79.347656 48 L 79.597656 51.75 L 79.347656 53.75 L 78.101562 56.5 L 77.101562 58.25 L 75.855469 59.75 L 74.609375 61 L 73.359375 62 L 72.859375 62.5 L 69.867188 64 L 67.371094 65 L 62.132812 65 L 60.882812 64.75 L 60.632812 65.25 L 60.632812 64.5 L 59.636719 64.75 L 59.636719 64.25 L 58.386719 64.25 L 58.386719 63.75 L 56.890625 63.5 L 56.890625 63 L 55.644531 62.75 L 54.394531 61.5 L 52.648438 60 L 52.398438 59 L 51.902344 59 L 50.402344 56.25 L 50.402344 55.75 L 49.65625 55.5 L 50.152344 55.5 L 50.152344 55 L 49.65625 54.75 L 49.65625 53.5 L 49.15625 53.25 L 49.15625 48.75 L 49.65625 46.75 L 50.402344 45 L 51.652344 42.75 L 53.398438 40.5 L 53.898438 40.5 L 53.898438 40 L 55.644531 38.5 L 56.390625 37.75 L 56.890625 37.75 L 57.390625 37.25 L 60.136719 36.25 L 61.132812 35.75 L 62.628906 36 Z M 63.128906 41.75 L 60.882812 42.25 L 58.386719 43.5 L 58.140625 44.25 L 57.390625 44.25 L 55.644531 46.75 L 54.894531 49 L 54.894531 52 L 55.644531 54.25 L 56.144531 55.25 L 56.640625 55.25 L 56.640625 56 L 57.390625 56 L 57.640625 57 L 58.140625 57 L 58.386719 57.5 L 60.632812 59 L 62.382812 59.5 L 64.128906 59.5 L 64.875 59.75 L 67.371094 59.25 L 69.117188 58.5 L 71.363281 56.5 L 72.859375 54 L 73.359375 51.5 L 73.359375 49.75 L 72.859375 47.75 L 72.363281 47.75 L 72.113281 46.25 L 71.363281 45.25 L 70.863281 45.25 L 70.617188 44.5 L 70.117188 44.5 L 69.867188 43.75 L 67.871094 42.5 L 64.875 41.75 Z M 63.128906 41.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.019608%,30.980392%,50.980392%)",
      fillOpacity: 1
    },
    d: "M 52.648438 72.5 L 52.898438 73.25 L 55.144531 73 L 60.136719 73 L 60.632812 73.25 L 60.882812 72.5 L 60.882812 73.25 L 63.128906 73 L 68.121094 73 L 68.617188 73.25 L 68.867188 72.5 L 68.867188 73.25 L 71.113281 73 L 76.605469 73 L 76.851562 72.5 L 76.851562 73 L 79.097656 72.75 L 81.34375 72.75 L 82.09375 73 L 83.589844 73.5 L 83.589844 74.75 L 81.59375 77.75 L 80.347656 79.25 L 80.347656 80 L 78.351562 80.5 L 76.105469 80.25 L 75.605469 80.75 L 75.605469 80.25 L 73.609375 80.5 L 73.359375 80.25 L 70.367188 80.5 L 67.871094 80.25 L 67.621094 80.75 L 67.621094 80.25 L 65.625 80.5 L 62.382812 80.5 L 61.382812 80.25 L 59.886719 80.25 L 59.636719 80.75 L 59.636719 80.25 L 57.640625 80.5 L 54.394531 80.5 L 50.402344 80.25 L 50.152344 79.25 L 49.65625 79 L 48.15625 76.25 L 47.660156 75.75 L 46.910156 73.75 L 47.410156 73.25 L 49.90625 73 L 52.152344 73 L 52.648438 73.25 Z M 52.648438 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.333333%,62.352941%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 83.839844 58.25 L 121.269531 58.25 L 122.265625 58.75 L 123.265625 60.5 L 123.015625 62 L 120.519531 63.75 L 120.269531 63.25 L 116.027344 63.5 L 112.785156 63.5 L 112.285156 63.75 L 112.285156 63.25 L 108.042969 63.5 L 104.800781 63.5 L 104.300781 63.75 L 104.300781 63.25 L 100.058594 63.5 L 96.816406 63.5 L 96.316406 63.75 L 96.316406 63.25 L 92.074219 63.5 L 88.832031 63.5 L 88.332031 63.75 L 88.332031 63.25 L 84.089844 63.5 L 80.847656 63.5 L 80.597656 63 L 81.34375 61.5 L 83.339844 58.5 Z M 83.839844 58.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(7.843137%,20%,32.54902%)",
      fillOpacity: 1
    },
    d: "M 10.480469 58.25 L 45.164062 58.25 L 46.410156 59.25 L 47.410156 60.75 L 47.660156 62 L 48.15625 62 L 48.15625 62.75 L 48.65625 63 L 48.15625 63 L 48.15625 63.5 L 40.921875 63.5 L 40.421875 63.75 L 40.421875 63.25 L 36.179688 63.5 L 32.9375 63.5 L 32.4375 63.75 L 32.4375 63.25 L 28.195312 63.5 L 24.953125 63.5 L 24.453125 63.75 L 24.453125 63.25 L 20.210938 63.5 L 16.96875 63.5 L 16.46875 63.75 L 16.46875 63.25 L 12.226562 63.5 L 10.480469 63.5 L 10.480469 63 L 9.230469 62.75 L 8.484375 62 L 8.234375 60.25 L 9.230469 58.75 Z M 10.480469 58.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.294118%,67.058824%,76.078431%)",
      fillOpacity: 1
    },
    d: "M 83.589844 37.5 L 83.839844 38 L 85.585938 37.75 L 91.078125 37.75 L 91.574219 38 L 91.824219 37.5 L 99.808594 37.5 L 101.058594 37.75 L 102.804688 37.75 L 103.304688 37.5 L 107.792969 37.5 L 107.792969 38 L 109.539062 37.75 L 115.03125 37.75 L 115.53125 38 L 115.777344 37.5 L 115.777344 38 L 117.527344 37.75 L 121.269531 37.75 L 121.269531 38.25 L 122.515625 38.5 L 122.765625 40 L 121.769531 42 L 120.519531 42.5 L 117.027344 42.75 L 114.28125 42.5 L 94.820312 42.5 L 93.074219 42.75 L 90.828125 42.75 L 89.828125 42.5 L 89.578125 43 L 89.578125 42.5 L 85.085938 42.75 L 83.339844 42 L 82.09375 40.75 L 80.847656 38.25 L 81.34375 37.75 L 83.089844 37.75 L 83.589844 38 Z M 83.589844 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(9.019608%,20.392157%,33.72549%)",
      fillOpacity: 1
    },
    d: "M 6.988281 44 L 7.234375 44.5 L 7.984375 44.25 L 14.472656 44.25 L 14.972656 44.5 L 15.222656 44 L 15.222656 44.5 L 15.96875 44.25 L 22.457031 44.25 L 22.957031 44.5 L 23.207031 44 L 23.207031 44.5 L 23.953125 44.25 L 30.441406 44.25 L 30.941406 44.5 L 31.191406 44 L 31.191406 44.5 L 31.9375 44.25 L 38.425781 44.25 L 38.925781 44.5 L 39.175781 44 L 39.175781 44.5 L 39.921875 44.25 L 43.417969 44.25 L 43.917969 45.25 L 42.667969 47.25 L 41.921875 48.25 L 41.421875 48.5 L 41.421875 49 L 39.921875 49.25 L 7.234375 49.25 L 5.238281 48.5 L 4.492188 47.25 L 4.492188 45.75 L 5.738281 44.75 L 6.988281 44.5 Z M 6.988281 44 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(8.235294%,21.960784%,38.431373%)",
      fillOpacity: 1
    },
    d: "M 11.726562 37.5 L 11.976562 38 L 13.722656 37.75 L 19.214844 37.75 L 19.710938 38 L 19.960938 37.5 L 19.960938 38 L 21.707031 37.75 L 27.199219 37.75 L 27.695312 38 L 27.945312 37.5 L 27.945312 38 L 29.691406 37.75 L 35.183594 37.75 L 35.683594 38 L 35.929688 37.5 L 35.929688 38 L 37.679688 37.75 L 43.167969 37.75 L 43.667969 38 L 43.917969 37.5 L 43.917969 38 L 45.664062 37.75 L 48.40625 38 L 47.410156 40 L 46.160156 42 L 45.414062 42.75 L 42.917969 42.75 L 41.921875 42.5 L 41.671875 43 L 41.671875 42.5 L 34.433594 42.5 L 33.933594 42.25 L 33.6875 43 L 33.6875 42.5 L 29.195312 42.75 L 26.949219 42.75 L 25.949219 42.5 L 25.699219 43 L 25.699219 42.5 L 11.230469 42.5 L 9.230469 41 L 9.480469 40.25 L 8.984375 40 L 9.480469 40 L 9.730469 38.75 L 10.980469 37.75 L 11.726562 38 Z M 11.726562 37.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.294118%,56.078431%,72.54902%)",
      fillOpacity: 1
    },
    d: "M 54.148438 19.25 L 55.644531 19.5 L 59.636719 19.5 L 62.382812 19.25 L 70.367188 19.25 L 73.359375 19.5 L 75.855469 19.5 L 78.101562 19.75 L 78.351562 19.25 L 79.847656 19.75 L 80.847656 20 L 81.34375 21.25 L 81.09375 23.5 L 79.847656 24.25 L 78.351562 24.5 L 75.855469 24.25 L 75.605469 24.75 L 75.605469 24.25 L 73.609375 24.5 L 70.367188 24.5 L 67.871094 24.25 L 67.621094 24.75 L 67.621094 24.25 L 65.625 24.5 L 62.382812 24.5 L 59.886719 24.25 L 59.636719 24.75 L 59.636719 24.25 L 57.640625 24.5 L 54.394531 24.5 L 51.902344 24.25 L 51.652344 24.75 L 51.402344 24.25 L 50.402344 24.25 L 49.65625 23 L 49.65625 21.25 L 50.652344 19.75 L 51.902344 19.5 L 54.148438 19.75 Z M 70.367188 24 Z M 70.367188 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(14.117647%,65.098039%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 86.835938 44 L 87.082031 44.5 L 87.832031 44.25 L 94.320312 44.25 L 94.820312 44.5 L 95.070312 44 L 95.070312 44.5 L 95.816406 44.25 L 102.304688 44.25 L 102.804688 44.5 L 103.054688 44 L 103.054688 44.5 L 103.800781 44.25 L 110.289062 44.25 L 110.789062 44.5 L 111.039062 44 L 111.039062 44.5 L 111.785156 44.25 L 116.027344 44.5 L 117.027344 45.5 L 117.027344 47.75 L 116.027344 49.25 L 115.53125 49.25 L 115.03125 49.75 L 115.03125 49.25 L 114.28125 49.5 L 111.039062 49.25 L 96.066406 49.25 L 95.566406 49.75 L 95.566406 49.25 L 92.074219 49.5 L 91.324219 49.25 L 91.078125 49.75 L 91.078125 49.25 L 90.328125 49.5 L 88.332031 49.25 L 86.835938 47.5 L 86.335938 47 L 85.335938 45.5 L 85.585938 44.5 L 86.335938 44.25 L 86.835938 44.5 Z M 86.835938 44 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.372549%,25.490196%,40.392157%)",
      fillOpacity: 1
    },
    d: "M 20.960938 51.25 L 40.421875 51.25 L 41.671875 52.5 L 42.667969 53.75 L 42.667969 54.25 L 43.167969 54.25 L 44.414062 57.5 L 43.167969 57.75 L 42.667969 56.75 L 41.671875 56.5 L 38.425781 56.5 L 35.929688 56.25 L 35.683594 56.75 L 35.683594 56.25 L 33.6875 56.5 L 30.441406 56.5 L 27.945312 56.25 L 27.695312 56.75 L 27.695312 56.25 L 25.699219 56.5 L 22.457031 56.5 L 19.960938 56.25 L 19.710938 56.75 L 19.710938 56.25 L 16.96875 56.25 L 16.96875 55.75 L 16.46875 55.75 L 15.71875 54.75 L 15.96875 52.75 L 17.21875 51.5 L 19.710938 51.5 Z M 20.960938 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(6.27451%,25.098039%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 62.878906 44 L 64.875 44 L 67.621094 45 L 68.867188 46 L 70.117188 48 L 70.617188 50.5 L 70.367188 52.5 L 68.867188 54.75 L 68.371094 55.5 L 67.621094 55.5 L 67.621094 56 L 66.375 56.25 L 66.125 56.75 L 62.382812 56.5 L 60.136719 55.5 L 60.136719 55 L 59.386719 55 L 58.886719 53.5 L 58.386719 53.5 L 57.890625 52 L 57.640625 49.75 L 58.386719 47.75 L 58.886719 47.75 L 59.386719 46.5 L 61.632812 44.75 L 62.878906 44.5 Z M 62.878906 44 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(15.686275%,60.784314%,72.54902%)",
      fillOpacity: 1
    },
    d: "M 92.824219 51.25 L 102.304688 51.25 L 105.300781 51.5 L 107.046875 51.75 L 108.292969 52.5 L 108.292969 53 L 108.792969 53.25 L 108.792969 54.75 L 108.292969 54.75 L 108.292969 55.5 L 107.046875 56.25 L 105.546875 56.5 L 102.304688 56.5 L 99.808594 56.25 L 99.558594 56.75 L 99.558594 56.25 L 97.5625 56.5 L 94.320312 56.5 L 91.824219 56.25 L 91.574219 56.75 L 91.574219 56.25 L 89.578125 56.5 L 86.835938 56.5 L 85.085938 56.75 L 85.335938 55.25 L 85.835938 55.25 L 86.085938 53.75 L 86.585938 53.75 L 87.082031 52.5 L 87.582031 51.75 L 88.832031 51.5 Z M 92.824219 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,69.411765%,74.901961%)",
      fillOpacity: 1
    },
    d: "M 118.023438 51.25 L 126.257812 51.25 L 127.757812 51.75 L 128.753906 52.75 L 129.003906 54.5 L 128.503906 54.5 L 128.253906 56 L 126.257812 56.5 L 123.765625 56.25 L 123.515625 56.75 L 123.515625 56.25 L 121.519531 56.5 L 118.273438 56.5 L 115.777344 56.25 L 115.53125 56.75 L 115.53125 56.25 L 113.535156 56 L 112.785156 55.5 L 112.785156 55 L 112.285156 54.75 L 112.535156 53 L 113.535156 52 L 114.03125 52 L 114.28125 51.5 L 117.277344 51.5 Z M 118.023438 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,55.686275%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 28.695312 72.5 L 28.945312 72.5 L 29.445312 74 L 30.191406 74.75 L 30.191406 82.75 L 29.941406 86.5 L 32.1875 86 L 33.933594 86.25 L 33.933594 86.75 L 28.695312 86.75 L 28.695312 73.5 L 22.707031 73.5 L 23.457031 73 L 28.195312 73 L 28.695312 73.25 Z M 28.695312 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 96.5 L 123.265625 97 L 122.765625 96.75 Z M 123.015625 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 96.5 L 115.28125 97 L 114.78125 96.75 Z M 115.03125 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 96.5 L 107.296875 97 L 106.796875 96.75 Z M 107.046875 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 96.5 L 99.308594 97 L 98.8125 96.75 Z M 99.0625 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 96.5 L 91.324219 97 L 90.828125 96.75 Z M 91.078125 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 96.5 L 83.339844 97 L 82.84375 96.75 Z M 83.089844 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 96.5 L 75.355469 97 L 74.855469 96.75 Z M 75.105469 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 96.5 L 67.371094 97 L 66.871094 96.75 Z M 67.121094 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 96.5 L 59.386719 97 L 58.886719 96.75 Z M 59.136719 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 96.5 L 51.402344 97 L 50.902344 96.75 Z M 51.152344 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 96.5 L 43.417969 97 L 42.917969 96.75 Z M 43.167969 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 96.5 L 35.433594 97 L 34.933594 96.75 Z M 35.183594 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 96.5 L 27.449219 97 L 26.949219 96.75 Z M 27.199219 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 96.5 L 19.460938 97 L 18.964844 96.75 Z M 19.214844 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 96.5 L 11.476562 97 L 10.980469 96.75 Z M 11.230469 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 96.5 L 3.492188 97 L 2.996094 96.75 Z M 3.242188 96.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 88.5 L 123.265625 89 L 122.765625 88.75 Z M 123.015625 88.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 88.5 L 115.28125 89 L 114.78125 88.75 Z M 115.03125 88.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 88.5 L 19.460938 89 L 18.964844 88.75 Z M 19.214844 88.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 88.5 L 11.476562 89 L 10.980469 88.75 Z M 11.230469 88.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 88.5 L 3.492188 89 L 2.996094 88.75 Z M 3.242188 88.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 80.5 L 123.265625 81 L 122.765625 80.75 Z M 123.015625 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 80.5 L 115.28125 81 L 114.78125 80.75 Z M 115.03125 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 80.5 L 99.308594 81 L 98.8125 80.75 Z M 99.0625 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 80.5 L 91.324219 81 L 90.828125 80.75 Z M 91.078125 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 80.5 L 83.339844 81 L 82.84375 80.75 Z M 83.089844 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 80.5 L 75.355469 81 L 74.855469 80.75 Z M 75.105469 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 80.5 L 67.371094 81 L 66.871094 80.75 Z M 67.121094 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 80.5 L 59.386719 81 L 58.886719 80.75 Z M 59.136719 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 80.5 L 51.402344 81 L 50.902344 80.75 Z M 51.152344 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 80.5 L 43.417969 81 L 42.917969 80.75 Z M 43.167969 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 80.5 L 35.433594 81 L 34.933594 80.75 Z M 35.183594 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 80.5 L 19.460938 81 L 18.964844 80.75 Z M 19.214844 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 80.5 L 11.476562 81 L 10.980469 80.75 Z M 11.230469 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 80.5 L 3.492188 81 L 2.996094 80.75 Z M 3.242188 80.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 72.5 L 123.265625 73 L 122.765625 72.75 Z M 123.015625 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 72.5 L 115.28125 73 L 114.78125 72.75 Z M 115.03125 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 72.5 L 107.296875 73 L 106.796875 72.75 Z M 107.046875 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 72.5 L 99.308594 73 L 98.8125 72.75 Z M 99.0625 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 72.5 L 91.324219 73 L 90.828125 72.75 Z M 91.078125 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 72.5 L 83.339844 73 L 82.84375 72.75 Z M 83.089844 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 72.5 L 75.355469 73 L 74.855469 72.75 Z M 75.105469 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 72.5 L 67.371094 73 L 66.871094 72.75 Z M 67.121094 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 72.5 L 59.386719 73 L 58.886719 72.75 Z M 59.136719 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 72.5 L 51.402344 73 L 50.902344 72.75 Z M 51.152344 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 72.5 L 43.417969 73 L 42.917969 72.75 Z M 43.167969 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 72.5 L 35.433594 73 L 34.933594 72.75 Z M 35.183594 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 72.5 L 27.449219 73 L 26.949219 72.75 Z M 27.199219 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 72.5 L 19.460938 73 L 18.964844 72.75 Z M 19.214844 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 72.5 L 11.476562 73 L 10.980469 72.75 Z M 11.230469 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 72.5 L 3.492188 73 L 2.996094 72.75 Z M 3.242188 72.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 64.5 L 123.265625 65 L 122.765625 64.75 Z M 123.015625 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 64.5 L 115.28125 65 L 114.78125 64.75 Z M 115.03125 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 64.5 L 107.296875 65 L 106.796875 64.75 Z M 107.046875 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 64.5 L 99.308594 65 L 98.8125 64.75 Z M 99.0625 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 64.5 L 91.324219 65 L 90.828125 64.75 Z M 91.078125 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 64.5 L 83.339844 65 L 82.84375 64.75 Z M 83.089844 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 64.5 L 75.355469 65 L 74.855469 64.75 Z M 75.105469 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 64.5 L 59.386719 65 L 58.886719 64.75 Z M 59.136719 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 64.5 L 51.402344 65 L 50.902344 64.75 Z M 51.152344 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 64.5 L 43.417969 65 L 42.917969 64.75 Z M 43.167969 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 64.5 L 35.433594 65 L 34.933594 64.75 Z M 35.183594 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 64.5 L 27.449219 65 L 26.949219 64.75 Z M 27.199219 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 64.5 L 19.460938 65 L 18.964844 64.75 Z M 19.214844 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 64.5 L 11.476562 65 L 10.980469 64.75 Z M 11.230469 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 64.5 L 3.492188 65 L 2.996094 64.75 Z M 3.242188 64.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 56.5 L 123.265625 57 L 122.765625 56.75 Z M 123.015625 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 56.5 L 115.28125 57 L 114.78125 56.75 Z M 115.03125 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 56.5 L 107.296875 57 L 106.796875 56.75 Z M 107.046875 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 56.5 L 99.308594 57 L 98.8125 56.75 Z M 99.0625 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 56.5 L 91.324219 57 L 90.828125 56.75 Z M 91.078125 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 56.5 L 83.339844 57 L 82.84375 56.75 Z M 83.089844 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 56.5 L 67.371094 57 L 66.871094 56.75 Z M 67.121094 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 56.5 L 59.386719 57 L 58.886719 56.75 Z M 59.136719 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 56.5 L 35.433594 57 L 34.933594 56.75 Z M 35.183594 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 56.5 L 27.449219 57 L 26.949219 56.75 Z M 27.199219 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 56.5 L 19.460938 57 L 18.964844 56.75 Z M 19.214844 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 56.5 L 11.476562 57 L 10.980469 56.75 Z M 11.230469 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 56.5 L 3.492188 57 L 2.996094 56.75 Z M 3.242188 56.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 48.5 L 123.265625 49 L 122.765625 48.75 Z M 123.015625 48.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 48.5 L 83.339844 49 L 82.84375 48.75 Z M 83.089844 48.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 48.5 L 43.417969 49 L 42.917969 48.75 Z M 43.167969 48.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 48.5 L 3.492188 49 L 2.996094 48.75 Z M 3.242188 48.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 40.5 L 123.265625 41 L 122.765625 40.75 Z M 123.015625 40.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 40.5 L 51.402344 41 L 50.902344 40.75 Z M 51.152344 40.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 40.5 L 3.492188 41 L 2.996094 40.75 Z M 3.242188 40.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 32.5 L 123.265625 33 L 122.765625 32.75 Z M 123.015625 32.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 32.5 L 75.355469 33 L 74.855469 32.75 Z M 75.105469 32.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 32.5 L 67.371094 33 L 66.871094 32.75 Z M 67.121094 32.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 32.5 L 59.386719 33 L 58.886719 32.75 Z M 59.136719 32.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 32.5 L 11.476562 33 L 10.980469 32.75 Z M 11.230469 32.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 32.5 L 3.492188 33 L 2.996094 32.75 Z M 3.242188 32.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 24.5 L 123.265625 25 L 122.765625 24.75 Z M 123.015625 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 24.5 L 115.28125 25 L 114.78125 24.75 Z M 115.03125 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 24.5 L 99.308594 25 L 98.8125 24.75 Z M 99.0625 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 24.5 L 91.324219 25 L 90.828125 24.75 Z M 91.078125 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 24.5 L 83.339844 25 L 82.84375 24.75 Z M 83.089844 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 24.5 L 75.355469 25 L 74.855469 24.75 Z M 75.105469 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 24.5 L 67.371094 25 L 66.871094 24.75 Z M 67.121094 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 24.5 L 59.386719 25 L 58.886719 24.75 Z M 59.136719 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 24.5 L 51.402344 25 L 50.902344 24.75 Z M 51.152344 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 24.5 L 43.417969 25 L 42.917969 24.75 Z M 43.167969 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 24.5 L 35.433594 25 L 34.933594 24.75 Z M 35.183594 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 24.5 L 19.460938 25 L 18.964844 24.75 Z M 19.214844 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 24.5 L 11.476562 25 L 10.980469 24.75 Z M 11.230469 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 24.5 L 3.492188 25 L 2.996094 24.75 Z M 3.242188 24.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 16.5 L 123.265625 17 L 122.765625 16.75 Z M 123.015625 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 16.5 L 115.28125 17 L 114.78125 16.75 Z M 115.03125 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 16.5 L 99.308594 17 L 98.8125 16.75 Z M 99.0625 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 16.5 L 91.324219 17 L 90.828125 16.75 Z M 91.078125 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 16.5 L 83.339844 17 L 82.84375 16.75 Z M 83.089844 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 16.5 L 75.355469 17 L 74.855469 16.75 Z M 75.105469 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 16.5 L 67.371094 17 L 66.871094 16.75 Z M 67.121094 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 16.5 L 59.386719 17 L 58.886719 16.75 Z M 59.136719 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 16.5 L 51.402344 17 L 50.902344 16.75 Z M 51.152344 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 16.5 L 43.417969 17 L 42.917969 16.75 Z M 43.167969 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 16.5 L 35.433594 17 L 34.933594 16.75 Z M 35.183594 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 16.5 L 19.460938 17 L 18.964844 16.75 Z M 19.214844 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 16.5 L 11.476562 17 L 10.980469 16.75 Z M 11.230469 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 16.5 L 3.492188 17 L 2.996094 16.75 Z M 3.242188 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 8.5 L 123.265625 9 L 122.765625 8.75 Z M 123.015625 8.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 8.5 L 115.28125 9 L 114.78125 8.75 Z M 115.03125 8.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 8.5 L 19.460938 9 L 18.964844 8.75 Z M 19.214844 8.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 8.5 L 11.476562 9 L 10.980469 8.75 Z M 11.230469 8.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 8.5 L 3.492188 9 L 2.996094 8.75 Z M 3.242188 8.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 0.5 L 123.265625 1 L 122.765625 0.75 Z M 123.015625 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 0.5 L 115.28125 1 L 114.78125 0.75 Z M 115.03125 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 0.5 L 107.296875 1 L 106.796875 0.75 Z M 107.046875 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 0.5 L 99.308594 1 L 98.8125 0.75 Z M 99.0625 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 0.5 L 91.324219 1 L 90.828125 0.75 Z M 91.078125 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 0.5 L 83.339844 1 L 82.84375 0.75 Z M 83.089844 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 0.5 L 75.355469 1 L 74.855469 0.75 Z M 75.105469 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 0.5 L 67.371094 1 L 66.871094 0.75 Z M 67.121094 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 0.5 L 59.386719 1 L 58.886719 0.75 Z M 59.136719 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 0.5 L 51.402344 1 L 50.902344 0.75 Z M 51.152344 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 0.5 L 43.417969 1 L 42.917969 0.75 Z M 43.167969 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 0.5 L 35.433594 1 L 34.933594 0.75 Z M 35.183594 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 0.5 L 27.449219 1 L 26.949219 0.75 Z M 27.199219 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 0.5 L 19.460938 1 L 18.964844 0.75 Z M 19.214844 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 0.5 L 11.476562 1 L 10.980469 0.75 Z M 11.230469 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 0.5 L 3.492188 1 L 2.996094 0.75 Z M 3.242188 0.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 97.75 L 130.75 98 Z M 130.25 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 97.75 L 122.765625 98 Z M 122.265625 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 97.75 L 114.78125 98 Z M 114.28125 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 106.296875 97.75 L 106.796875 98 Z M 106.296875 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 97.75 L 98.8125 98 Z M 98.3125 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 97.75 L 90.828125 98 Z M 90.328125 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 97.75 L 82.84375 98 Z M 82.34375 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 74.359375 97.75 L 74.855469 98 Z M 74.359375 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 97.75 L 66.871094 98 Z M 66.375 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 58.386719 97.75 L 58.886719 98 Z M 58.386719 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 97.75 L 50.902344 98 Z M 50.402344 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 97.75 L 42.917969 98 Z M 42.417969 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 97.75 L 34.933594 98 Z M 34.433594 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.449219 97.75 L 26.949219 98 Z M 26.449219 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 97.75 L 18.964844 98 Z M 18.464844 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 97.75 L 10.980469 98 Z M 10.480469 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 97.75 L 2.996094 98 Z M 2.496094 97.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 96.25 L 126.757812 96.5 Z M 126.257812 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 96.25 L 118.773438 96.5 Z M 118.273438 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 110.289062 96.25 L 110.789062 96.5 Z M 110.289062 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 96.25 L 102.804688 96.5 Z M 102.304688 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 96.25 L 94.820312 96.5 Z M 94.320312 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 96.25 L 86.835938 96.5 Z M 86.335938 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 96.25 L 78.847656 96.5 Z M 78.351562 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 96.25 L 70.863281 96.5 Z M 70.367188 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.382812 96.25 L 62.878906 96.5 Z M 62.382812 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.394531 96.25 L 54.894531 96.5 Z M 54.394531 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 96.25 L 46.910156 96.5 Z M 46.410156 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 96.25 L 38.925781 96.5 Z M 38.425781 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 96.25 L 30.941406 96.5 Z M 30.441406 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.457031 96.25 L 22.957031 96.5 Z M 22.457031 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 96.25 L 14.972656 96.5 Z M 14.472656 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 96.25 L 6.988281 96.5 Z M 6.488281 96.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 96 L 129.253906 96.25 Z M 128.753906 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 96 L 121.269531 96.25 Z M 120.769531 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 96 L 113.285156 96.25 Z M 112.785156 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 104.800781 96 L 105.300781 96.25 Z M 104.800781 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 96 L 97.3125 96.25 Z M 96.816406 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 96 L 89.328125 96.25 Z M 88.832031 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 96 L 81.34375 96.25 Z M 80.847656 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72.859375 96 L 73.359375 96.25 Z M 72.859375 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 64.875 96 L 65.375 96.25 Z M 64.875 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 96 L 57.390625 96.25 Z M 56.890625 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 96 L 49.40625 96.25 Z M 48.90625 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 96 L 41.421875 96.25 Z M 40.921875 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 96 L 33.4375 96.25 Z M 32.9375 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.953125 96 L 25.453125 96.25 Z M 24.953125 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 96 L 17.464844 96.25 Z M 16.96875 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 96 L 9.480469 96.25 Z M 8.984375 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 96 L 1.496094 96.25 Z M 1 96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 95.75 L 128.253906 96 Z M 127.757812 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 95.75 L 123.515625 96 Z M 123.015625 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 95.75 L 120.269531 96 Z M 119.769531 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 95.75 L 115.53125 96 Z M 115.03125 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 95.75 L 112.285156 96 Z M 111.785156 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 95.75 L 107.542969 96 Z M 107.046875 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 103.800781 95.75 L 104.300781 96 Z M 103.800781 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 95.75 L 99.558594 96 Z M 99.0625 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 95.816406 95.75 L 96.316406 96 Z M 95.816406 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 95.75 L 91.574219 96 Z M 91.078125 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 87.832031 95.75 L 88.332031 96 Z M 87.832031 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 95.75 L 83.589844 96 Z M 83.089844 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 95.75 L 80.347656 96 Z M 79.847656 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 95.75 L 75.605469 96 Z M 75.105469 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 71.863281 95.75 L 72.363281 96 Z M 71.863281 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 95.75 L 67.621094 96 Z M 67.121094 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 63.878906 95.75 L 64.378906 96 Z M 63.878906 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 95.75 L 59.636719 96 Z M 59.136719 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.894531 95.75 L 56.390625 96 Z M 55.894531 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 95.75 L 51.652344 96 Z M 51.152344 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 95.75 L 48.40625 96 Z M 47.910156 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 95.75 L 43.667969 96 Z M 43.167969 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.921875 95.75 L 40.421875 96 Z M 39.921875 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 95.75 L 35.683594 96 Z M 35.183594 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.9375 95.75 L 32.4375 96 Z M 31.9375 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 95.75 L 27.695312 96 Z M 27.199219 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.953125 95.75 L 24.453125 96 Z M 23.953125 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 95.75 L 19.710938 96 Z M 19.214844 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 95.75 L 16.46875 96 Z M 15.96875 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 95.75 L 11.726562 96 Z M 11.230469 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 95.75 L 8.484375 96 Z M 7.984375 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 95.75 L 3.742188 96 Z M 3.242188 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 95.75 L 0.5 96 Z M 0 95.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 95.5 L 130 95.75 Z M 129.503906 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 95.5 L 122.015625 95.75 Z M 121.519531 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 95.5 L 114.03125 95.75 Z M 113.535156 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 105.546875 95.5 L 106.046875 95.75 Z M 105.546875 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5625 95.5 L 98.0625 95.75 Z M 97.5625 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 89.578125 95.5 L 90.078125 95.75 Z M 89.578125 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 95.5 L 82.09375 95.75 Z M 81.59375 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 73.609375 95.5 L 74.109375 95.75 Z M 73.609375 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.625 95.5 L 66.125 95.75 Z M 65.625 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.640625 95.5 L 58.140625 95.75 Z M 57.640625 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 95.5 L 50.152344 95.75 Z M 49.65625 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.671875 95.5 L 42.167969 95.75 Z M 41.671875 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.6875 95.5 L 34.183594 95.75 Z M 33.6875 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25.699219 95.5 L 26.199219 95.75 Z M 25.699219 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 95.5 L 18.214844 95.75 Z M 17.714844 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 95.5 L 10.230469 95.75 Z M 9.730469 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 95.5 L 2.246094 95.75 Z M 1.746094 95.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 91.25 L 125.261719 91.5 Z M 124.761719 91.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 91.25 L 117.277344 91.5 Z M 116.777344 91.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 91.25 L 21.460938 91.5 Z M 20.960938 91.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 91.25 L 13.472656 91.5 Z M 12.976562 91.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 91.25 L 5.488281 91.5 Z M 4.992188 91.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 89.75 L 130.75 90 Z M 130.25 89.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 89.75 L 122.765625 90 Z M 122.265625 89.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 89.75 L 114.78125 90 Z M 114.28125 89.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 89.75 L 18.964844 90 Z M 18.464844 89.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 89.75 L 10.980469 90 Z M 10.480469 89.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 89.75 L 2.996094 90 Z M 2.496094 89.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 88.25 L 126.757812 88.5 Z M 126.257812 88.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 88.25 L 118.773438 88.5 Z M 118.273438 88.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 88.25 L 14.972656 88.5 Z M 14.472656 88.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 88.25 L 6.988281 88.5 Z M 6.488281 88.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 88 L 129.253906 88.25 Z M 128.753906 88 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 88 L 121.269531 88.25 Z M 120.769531 88 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 88 L 113.285156 88.25 Z M 112.785156 88 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 88 L 17.464844 88.25 Z M 16.96875 88 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 88 L 9.480469 88.25 Z M 8.984375 88 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 88 L 1.496094 88.25 Z M 1 88 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 87.75 L 128.253906 88 Z M 127.757812 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 87.75 L 123.515625 88 Z M 123.015625 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 87.75 L 120.269531 88 Z M 119.769531 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 87.75 L 115.53125 88 Z M 115.03125 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 87.75 L 112.285156 88 Z M 111.785156 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 87.75 L 19.710938 88 Z M 19.214844 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 87.75 L 16.46875 88 Z M 15.96875 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 87.75 L 11.726562 88 Z M 11.230469 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 87.75 L 8.484375 88 Z M 7.984375 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 87.75 L 3.742188 88 Z M 3.242188 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 87.75 L 0.5 88 Z M 0 87.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 87.5 L 130 87.75 Z M 129.503906 87.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 87.5 L 122.015625 87.75 Z M 121.519531 87.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 87.5 L 114.03125 87.75 Z M 113.535156 87.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 87.5 L 18.214844 87.75 Z M 17.714844 87.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 87.5 L 10.230469 87.75 Z M 9.730469 87.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 87.5 L 2.246094 87.75 Z M 1.746094 87.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 83.25 L 125.261719 83.5 Z M 124.761719 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 83.25 L 117.277344 83.5 Z M 116.777344 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.808594 83.25 L 101.308594 83.5 Z M 100.808594 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.824219 83.25 L 93.320312 83.5 Z M 92.824219 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.839844 83.25 L 85.335938 83.5 Z M 84.839844 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.851562 83.25 L 77.351562 83.5 Z M 76.851562 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 68.867188 83.25 L 69.367188 83.5 Z M 68.867188 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 60.882812 83.25 L 61.382812 83.5 Z M 60.882812 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 52.898438 83.25 L 53.398438 83.5 Z M 52.898438 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.914062 83.25 L 45.414062 83.5 Z M 44.914062 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.929688 83.25 L 37.429688 83.5 Z M 36.929688 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 83.25 L 21.460938 83.5 Z M 20.960938 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 83.25 L 13.472656 83.5 Z M 12.976562 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 83.25 L 5.488281 83.5 Z M 4.992188 83.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 81.75 L 130.75 82 Z M 130.25 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 81.75 L 122.765625 82 Z M 122.265625 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 81.75 L 114.78125 82 Z M 114.28125 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 81.75 L 98.8125 82 Z M 98.3125 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 81.75 L 90.828125 82 Z M 90.328125 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 81.75 L 82.84375 82 Z M 82.34375 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 74.359375 81.75 L 74.855469 82 Z M 74.359375 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 81.75 L 66.871094 82 Z M 66.375 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 58.386719 81.75 L 58.886719 82 Z M 58.386719 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 81.75 L 50.902344 82 Z M 50.402344 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 81.75 L 42.917969 82 Z M 42.417969 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 81.75 L 34.933594 82 Z M 34.433594 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 81.75 L 18.964844 82 Z M 18.464844 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 81.75 L 10.980469 82 Z M 10.480469 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 81.75 L 2.996094 82 Z M 2.496094 81.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 80.25 L 126.757812 80.5 Z M 126.257812 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 80.25 L 118.773438 80.5 Z M 118.273438 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 80.25 L 102.804688 80.5 Z M 102.304688 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 80.25 L 94.820312 80.5 Z M 94.320312 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 80.25 L 86.835938 80.5 Z M 86.335938 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 80.25 L 46.910156 80.5 Z M 46.410156 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 80.25 L 38.925781 80.5 Z M 38.425781 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 80.25 L 30.941406 80.5 Z M 30.441406 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 80.25 L 14.972656 80.5 Z M 14.472656 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 80.25 L 6.988281 80.5 Z M 6.488281 80.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 80 L 129.253906 80.25 Z M 128.753906 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 80 L 121.269531 80.25 Z M 120.769531 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 80 L 113.285156 80.25 Z M 112.785156 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 80 L 97.3125 80.25 Z M 96.816406 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 80 L 89.328125 80.25 Z M 88.832031 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 80 L 81.34375 80.25 Z M 80.847656 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 80 L 49.40625 80.25 Z M 48.90625 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 80 L 41.421875 80.25 Z M 40.921875 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 80 L 33.4375 80.25 Z M 32.9375 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 80 L 17.464844 80.25 Z M 16.96875 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 80 L 9.480469 80.25 Z M 8.984375 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 80 L 1.496094 80.25 Z M 1 80 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 79.75 L 128.253906 80 Z M 127.757812 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 79.75 L 123.515625 80 Z M 123.015625 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 79.75 L 120.269531 80 Z M 119.769531 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 79.75 L 115.53125 80 Z M 115.03125 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 79.75 L 112.285156 80 Z M 111.785156 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 79.75 L 99.558594 80 Z M 99.0625 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 95.816406 79.75 L 96.316406 80 Z M 95.816406 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 79.75 L 91.574219 80 Z M 91.078125 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 87.832031 79.75 L 88.332031 80 Z M 87.832031 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 79.75 L 83.589844 80 Z M 83.089844 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 79.75 L 48.40625 80 Z M 47.910156 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 79.75 L 43.667969 80 Z M 43.167969 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.921875 79.75 L 40.421875 80 Z M 39.921875 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 79.75 L 35.683594 80 Z M 35.183594 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.9375 79.75 L 32.4375 80 Z M 31.9375 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 79.75 L 19.710938 80 Z M 19.214844 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 79.75 L 16.46875 80 Z M 15.96875 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 79.75 L 11.726562 80 Z M 11.230469 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 79.75 L 8.484375 80 Z M 7.984375 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 79.75 L 3.742188 80 Z M 3.242188 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 79.75 L 0.5 80 Z M 0 79.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 79.5 L 130 79.75 Z M 129.503906 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 79.5 L 122.015625 79.75 Z M 121.519531 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 79.5 L 114.03125 79.75 Z M 113.535156 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5625 79.5 L 98.0625 79.75 Z M 97.5625 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 89.578125 79.5 L 90.078125 79.75 Z M 89.578125 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 79.5 L 82.09375 79.75 Z M 81.59375 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 79.5 L 50.152344 79.75 Z M 49.65625 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.671875 79.5 L 42.167969 79.75 Z M 41.671875 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.6875 79.5 L 34.183594 79.75 Z M 33.6875 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 79.5 L 18.214844 79.75 Z M 17.714844 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 79.5 L 10.230469 79.75 Z M 9.730469 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 79.5 L 2.246094 79.75 Z M 1.746094 79.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 75.25 L 125.261719 75.5 Z M 124.761719 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 75.25 L 117.277344 75.5 Z M 116.777344 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.808594 75.25 L 101.308594 75.5 Z M 100.808594 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.824219 75.25 L 93.320312 75.5 Z M 92.824219 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.839844 75.25 L 85.335938 75.5 Z M 84.839844 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.914062 75.25 L 45.414062 75.5 Z M 44.914062 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.929688 75.25 L 37.429688 75.5 Z M 36.929688 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 75.25 L 21.460938 75.5 Z M 20.960938 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 75.25 L 13.472656 75.5 Z M 12.976562 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 75.25 L 5.488281 75.5 Z M 4.992188 75.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 73.75 L 130.75 74 Z M 130.25 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 73.75 L 122.765625 74 Z M 122.265625 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 73.75 L 114.78125 74 Z M 114.28125 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 73.75 L 98.8125 74 Z M 98.3125 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 73.75 L 90.828125 74 Z M 90.328125 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 73.75 L 42.917969 74 Z M 42.417969 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 73.75 L 34.933594 74 Z M 34.433594 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 73.75 L 18.964844 74 Z M 18.464844 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 73.75 L 10.980469 74 Z M 10.480469 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 73.75 L 2.996094 74 Z M 2.496094 73.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 72.25 L 126.757812 72.5 Z M 126.257812 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 72.25 L 118.773438 72.5 Z M 118.273438 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 110.289062 72.25 L 110.789062 72.5 Z M 110.289062 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 72.25 L 102.804688 72.5 Z M 102.304688 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 72.25 L 94.820312 72.5 Z M 94.320312 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 72.25 L 86.835938 72.5 Z M 86.335938 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 72.25 L 78.847656 72.5 Z M 78.351562 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 72.25 L 70.863281 72.5 Z M 70.367188 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.382812 72.25 L 62.878906 72.5 Z M 62.382812 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.394531 72.25 L 54.894531 72.5 Z M 54.394531 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 72.25 L 46.910156 72.5 Z M 46.410156 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 72.25 L 38.925781 72.5 Z M 38.425781 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 72.25 L 30.941406 72.5 Z M 30.441406 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.457031 72.25 L 22.957031 72.5 Z M 22.457031 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 72.25 L 14.972656 72.5 Z M 14.472656 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 72.25 L 6.988281 72.5 Z M 6.488281 72.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 72 L 129.253906 72.25 Z M 128.753906 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 72 L 121.269531 72.25 Z M 120.769531 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 72 L 113.285156 72.25 Z M 112.785156 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 104.800781 72 L 105.300781 72.25 Z M 104.800781 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 72 L 97.3125 72.25 Z M 96.816406 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 72 L 89.328125 72.25 Z M 88.832031 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 72 L 81.34375 72.25 Z M 80.847656 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72.859375 72 L 73.359375 72.25 Z M 72.859375 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 64.875 72 L 65.375 72.25 Z M 64.875 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 72 L 57.390625 72.25 Z M 56.890625 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 72 L 49.40625 72.25 Z M 48.90625 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 72 L 41.421875 72.25 Z M 40.921875 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 72 L 33.4375 72.25 Z M 32.9375 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.953125 72 L 25.453125 72.25 Z M 24.953125 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 72 L 17.464844 72.25 Z M 16.96875 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 72 L 9.480469 72.25 Z M 8.984375 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 72 L 1.496094 72.25 Z M 1 72 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 71.75 L 128.253906 72 Z M 127.757812 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 71.75 L 123.515625 72 Z M 123.015625 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 71.75 L 120.269531 72 Z M 119.769531 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 71.75 L 115.53125 72 Z M 115.03125 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 71.75 L 112.285156 72 Z M 111.785156 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 71.75 L 107.542969 72 Z M 107.046875 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 103.800781 71.75 L 104.300781 72 Z M 103.800781 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 71.75 L 99.558594 72 Z M 99.0625 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 95.816406 71.75 L 96.316406 72 Z M 95.816406 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 71.75 L 91.574219 72 Z M 91.078125 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 87.832031 71.75 L 88.332031 72 Z M 87.832031 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 71.75 L 83.589844 72 Z M 83.089844 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 71.75 L 80.347656 72 Z M 79.847656 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 71.75 L 75.605469 72 Z M 75.105469 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 71.863281 71.75 L 72.363281 72 Z M 71.863281 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 71.75 L 67.621094 72 Z M 67.121094 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 63.878906 71.75 L 64.378906 72 Z M 63.878906 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 71.75 L 59.636719 72 Z M 59.136719 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.894531 71.75 L 56.390625 72 Z M 55.894531 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 71.75 L 51.652344 72 Z M 51.152344 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 71.75 L 48.40625 72 Z M 47.910156 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 71.75 L 43.667969 72 Z M 43.167969 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.921875 71.75 L 40.421875 72 Z M 39.921875 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 71.75 L 35.683594 72 Z M 35.183594 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.9375 71.75 L 32.4375 72 Z M 31.9375 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 71.75 L 27.695312 72 Z M 27.199219 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.953125 71.75 L 24.453125 72 Z M 23.953125 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 71.75 L 19.710938 72 Z M 19.214844 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 71.75 L 16.46875 72 Z M 15.96875 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 71.75 L 11.726562 72 Z M 11.230469 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 71.75 L 8.484375 72 Z M 7.984375 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 71.75 L 3.742188 72 Z M 3.242188 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 71.75 L 0.5 72 Z M 0 71.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 71.5 L 130 71.75 Z M 129.503906 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 71.5 L 122.015625 71.75 Z M 121.519531 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 71.5 L 114.03125 71.75 Z M 113.535156 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 105.546875 71.5 L 106.046875 71.75 Z M 105.546875 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5625 71.5 L 98.0625 71.75 Z M 97.5625 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 89.578125 71.5 L 90.078125 71.75 Z M 89.578125 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 71.5 L 82.09375 71.75 Z M 81.59375 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 73.609375 71.5 L 74.109375 71.75 Z M 73.609375 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.625 71.5 L 66.125 71.75 Z M 65.625 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.640625 71.5 L 58.140625 71.75 Z M 57.640625 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 71.5 L 50.152344 71.75 Z M 49.65625 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.671875 71.5 L 42.167969 71.75 Z M 41.671875 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.6875 71.5 L 34.183594 71.75 Z M 33.6875 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25.699219 71.5 L 26.199219 71.75 Z M 25.699219 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 71.5 L 18.214844 71.75 Z M 17.714844 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 71.5 L 10.230469 71.75 Z M 9.730469 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 71.5 L 2.246094 71.75 Z M 1.746094 71.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 67.25 L 125.261719 67.5 Z M 124.761719 67.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 67.25 L 13.472656 67.5 Z M 12.976562 67.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 67.25 L 5.488281 67.5 Z M 4.992188 67.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 65.75 L 130.75 66 Z M 130.25 65.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 65.75 L 122.765625 66 Z M 122.265625 65.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 65.75 L 10.980469 66 Z M 10.480469 65.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 65.75 L 2.996094 66 Z M 2.496094 65.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 64.25 L 126.757812 64.5 Z M 126.257812 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 64.25 L 118.773438 64.5 Z M 118.273438 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 110.289062 64.25 L 110.789062 64.5 Z M 110.289062 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 64.25 L 102.804688 64.5 Z M 102.304688 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 64.25 L 94.820312 64.5 Z M 94.320312 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 64.25 L 86.835938 64.5 Z M 86.335938 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 64.25 L 78.847656 64.5 Z M 78.351562 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 64.25 L 70.863281 64.5 Z M 70.367188 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.394531 64.25 L 54.894531 64.5 Z M 54.394531 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 64.25 L 46.910156 64.5 Z M 46.410156 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 64.25 L 38.925781 64.5 Z M 38.425781 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 64.25 L 30.941406 64.5 Z M 30.441406 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.457031 64.25 L 22.957031 64.5 Z M 22.457031 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 64.25 L 14.972656 64.5 Z M 14.472656 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 64.25 L 6.988281 64.5 Z M 6.488281 64.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 64 L 129.253906 64.25 Z M 128.753906 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 64 L 121.269531 64.25 Z M 120.769531 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 64 L 113.285156 64.25 Z M 112.785156 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 104.800781 64 L 105.300781 64.25 Z M 104.800781 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 64 L 97.3125 64.25 Z M 96.816406 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 64 L 89.328125 64.25 Z M 88.832031 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 64 L 81.34375 64.25 Z M 80.847656 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72.859375 64 L 73.359375 64.25 Z M 72.859375 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 64 L 57.390625 64.25 Z M 56.890625 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 64 L 49.40625 64.25 Z M 48.90625 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 64 L 41.421875 64.25 Z M 40.921875 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 64 L 33.4375 64.25 Z M 32.9375 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.953125 64 L 25.453125 64.25 Z M 24.953125 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 64 L 17.464844 64.25 Z M 16.96875 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 64 L 9.480469 64.25 Z M 8.984375 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 64 L 1.496094 64.25 Z M 1 64 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 63.75 L 128.253906 64 Z M 127.757812 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 63.75 L 123.515625 64 Z M 123.015625 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 63.75 L 120.269531 64 Z M 119.769531 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 63.75 L 115.53125 64 Z M 115.03125 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 63.75 L 112.285156 64 Z M 111.785156 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 107.046875 63.75 L 107.542969 64 Z M 107.046875 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 103.800781 63.75 L 104.300781 64 Z M 103.800781 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 63.75 L 99.558594 64 Z M 99.0625 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 95.816406 63.75 L 96.316406 64 Z M 95.816406 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 63.75 L 91.574219 64 Z M 91.078125 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 87.832031 63.75 L 88.332031 64 Z M 87.832031 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 63.75 L 83.589844 64 Z M 83.089844 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 63.75 L 80.347656 64 Z M 79.847656 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 63.75 L 75.605469 64 Z M 75.105469 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 71.863281 63.75 L 72.363281 64 Z M 71.863281 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.894531 63.75 L 56.390625 64 Z M 55.894531 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 63.75 L 51.652344 64 Z M 51.152344 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 63.75 L 48.40625 64 Z M 47.910156 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 63.75 L 43.667969 64 Z M 43.167969 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.921875 63.75 L 40.421875 64 Z M 39.921875 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 63.75 L 35.683594 64 Z M 35.183594 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.9375 63.75 L 32.4375 64 Z M 31.9375 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.199219 63.75 L 27.695312 64 Z M 27.199219 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 23.953125 63.75 L 24.453125 64 Z M 23.953125 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 63.75 L 19.710938 64 Z M 19.214844 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 63.75 L 16.46875 64 Z M 15.96875 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 63.75 L 11.726562 64 Z M 11.230469 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 63.75 L 8.484375 64 Z M 7.984375 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 63.75 L 3.742188 64 Z M 3.242188 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 63.75 L 0.5 64 Z M 0 63.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 63.5 L 130 63.75 Z M 129.503906 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 63.5 L 122.015625 63.75 Z M 121.519531 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 63.5 L 114.03125 63.75 Z M 113.535156 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 105.546875 63.5 L 106.046875 63.75 Z M 105.546875 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5625 63.5 L 98.0625 63.75 Z M 97.5625 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 89.578125 63.5 L 90.078125 63.75 Z M 89.578125 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 63.5 L 82.09375 63.75 Z M 81.59375 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 73.609375 63.5 L 74.109375 63.75 Z M 73.609375 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 63.5 L 50.152344 63.75 Z M 49.65625 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.671875 63.5 L 42.167969 63.75 Z M 41.671875 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.6875 63.5 L 34.183594 63.75 Z M 33.6875 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 25.699219 63.5 L 26.199219 63.75 Z M 25.699219 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 63.5 L 18.214844 63.75 Z M 17.714844 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 63.5 L 10.230469 63.75 Z M 9.730469 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 63.5 L 2.246094 63.75 Z M 1.746094 63.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 59.25 L 125.261719 59.5 Z M 124.761719 59.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.851562 59.25 L 77.351562 59.5 Z M 76.851562 59.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 59.25 L 5.488281 59.5 Z M 4.992188 59.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 57.75 L 130.75 58 Z M 130.25 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 57.75 L 122.765625 58 Z M 122.265625 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 57.75 L 114.78125 58 Z M 114.28125 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 106.296875 57.75 L 106.796875 58 Z M 106.296875 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 57.75 L 98.8125 58 Z M 98.3125 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 57.75 L 90.828125 58 Z M 90.328125 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 57.75 L 82.84375 58 Z M 82.34375 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 57.75 L 66.871094 58 Z M 66.375 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 57.75 L 50.902344 58 Z M 50.402344 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 57.75 L 42.917969 58 Z M 42.417969 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 57.75 L 34.933594 58 Z M 34.433594 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.449219 57.75 L 26.949219 58 Z M 26.449219 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 57.75 L 18.964844 58 Z M 18.464844 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 57.75 L 10.980469 58 Z M 10.480469 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 57.75 L 2.996094 58 Z M 2.496094 57.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 110.289062 56.25 L 110.789062 56.5 Z M 110.289062 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 56.25 L 78.847656 56.5 Z M 78.351562 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 56.25 L 70.863281 56.5 Z M 70.367188 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 56.25 L 46.910156 56.5 Z M 46.410156 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 56.25 L 14.972656 56.5 Z M 14.472656 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 56.25 L 6.988281 56.5 Z M 6.488281 56.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 56 L 129.253906 56.25 Z M 128.753906 56 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 56 L 113.285156 56.25 Z M 112.785156 56 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 56 L 81.34375 56.25 Z M 80.847656 56 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 56 L 49.40625 56.25 Z M 48.90625 56 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 56 L 9.480469 56.25 Z M 8.984375 56 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 56 L 1.496094 56.25 Z M 1 56 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 55.75 L 112.285156 56 Z M 111.785156 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 55.75 L 83.589844 56 Z M 83.089844 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 55.75 L 80.347656 56 Z M 79.847656 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 55.75 L 59.636719 56 Z M 59.136719 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 55.75 L 48.40625 56 Z M 47.910156 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 55.75 L 16.46875 56 Z M 15.96875 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 55.75 L 11.726562 56 Z M 11.230469 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 55.75 L 8.484375 56 Z M 7.984375 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 55.75 L 3.742188 56 Z M 3.242188 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 55.75 L 0.5 56 Z M 0 55.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 55.5 L 130 55.75 Z M 129.503906 55.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 55.5 L 82.09375 55.75 Z M 81.59375 55.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.640625 55.5 L 58.140625 55.75 Z M 57.640625 55.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 55.5 L 10.230469 55.75 Z M 9.730469 55.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 55.5 L 2.246094 55.75 Z M 1.746094 55.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 51.25 L 117.277344 51.5 Z M 116.777344 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 108.792969 51.25 L 109.292969 51.5 Z M 108.792969 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.839844 51.25 L 85.335938 51.5 Z M 84.839844 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.914062 51.25 L 45.414062 51.5 Z M 44.914062 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 51.25 L 13.472656 51.5 Z M 12.976562 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 51.25 L 5.488281 51.5 Z M 4.992188 51.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 49.75 L 130.75 50 Z M 130.25 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 49.75 L 122.765625 50 Z M 122.265625 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 49.75 L 114.78125 50 Z M 114.28125 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 106.296875 49.75 L 106.796875 50 Z M 106.296875 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 49.75 L 98.8125 50 Z M 98.3125 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 49.75 L 90.828125 50 Z M 90.328125 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 49.75 L 82.84375 50 Z M 82.34375 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 49.75 L 42.917969 50 Z M 42.417969 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 49.75 L 34.933594 50 Z M 34.433594 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.449219 49.75 L 26.949219 50 Z M 26.449219 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 49.75 L 18.964844 50 Z M 18.464844 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 49.75 L 10.980469 50 Z M 10.480469 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 49.75 L 2.996094 50 Z M 2.496094 49.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 48.25 L 126.757812 48.5 Z M 126.257812 48.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 48.25 L 118.773438 48.5 Z M 118.273438 48.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 48.25 L 86.835938 48.5 Z M 86.335938 48.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 48.25 L 70.863281 48.5 Z M 70.367188 48.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 48.25 L 46.910156 48.5 Z M 46.410156 48.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 48 L 129.253906 48.25 Z M 128.753906 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 48 L 121.269531 48.25 Z M 120.769531 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 48 L 81.34375 48.25 Z M 80.847656 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 48 L 57.390625 48.25 Z M 56.890625 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 48 L 49.40625 48.25 Z M 48.90625 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 48 L 1.496094 48.25 Z M 1 48 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 47.75 L 128.253906 48 Z M 127.757812 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 47.75 L 123.515625 48 Z M 123.015625 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 47.75 L 120.269531 48 Z M 119.769531 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 47.75 L 83.589844 48 Z M 83.089844 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 47.75 L 80.347656 48 Z M 79.847656 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 71.863281 47.75 L 72.363281 48 Z M 71.863281 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.894531 47.75 L 56.390625 48 Z M 55.894531 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 47.75 L 48.40625 48 Z M 47.910156 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 47.75 L 43.667969 48 Z M 43.167969 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 47.75 L 3.742188 48 Z M 3.242188 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 47.75 L 0.5 48 Z M 0 47.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 47.5 L 130 47.75 Z M 129.503906 47.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 47.5 L 122.015625 47.75 Z M 121.519531 47.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 47.5 L 82.09375 47.75 Z M 81.59375 47.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.640625 47.5 L 58.140625 47.75 Z M 57.640625 47.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 47.5 L 2.246094 47.75 Z M 1.746094 47.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 43.25 L 125.261719 43.5 Z M 124.761719 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 43.25 L 117.277344 43.5 Z M 116.777344 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 108.792969 43.25 L 109.292969 43.5 Z M 108.792969 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.808594 43.25 L 101.308594 43.5 Z M 100.808594 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.824219 43.25 L 93.320312 43.5 Z M 92.824219 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.839844 43.25 L 85.335938 43.5 Z M 84.839844 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 60.882812 43.25 L 61.382812 43.5 Z M 60.882812 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.914062 43.25 L 45.414062 43.5 Z M 44.914062 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.929688 43.25 L 37.429688 43.5 Z M 36.929688 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 28.945312 43.25 L 29.445312 43.5 Z M 28.945312 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 43.25 L 21.460938 43.5 Z M 20.960938 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 43.25 L 13.472656 43.5 Z M 12.976562 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 43.25 L 5.488281 43.5 Z M 4.992188 43.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 41.75 L 130.75 42 Z M 130.25 41.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 41.75 L 122.765625 42 Z M 122.265625 41.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 41.75 L 82.84375 42 Z M 82.34375 41.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 41.75 L 50.902344 42 Z M 50.402344 41.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 41.75 L 2.996094 42 Z M 2.496094 41.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 40.25 L 126.757812 40.5 Z M 126.257812 40.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 40.25 L 78.847656 40.5 Z M 78.351562 40.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 40.25 L 6.988281 40.5 Z M 6.488281 40.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 40 L 129.253906 40.25 Z M 128.753906 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 40 L 81.34375 40.25 Z M 80.847656 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 40 L 49.40625 40.25 Z M 48.90625 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 40 L 1.496094 40.25 Z M 1 40 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 39.75 L 128.253906 40 Z M 127.757812 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 39.75 L 123.515625 40 Z M 123.015625 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 39.75 L 80.347656 40 Z M 79.847656 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 39.75 L 75.605469 40 Z M 75.105469 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 39.75 L 51.652344 40 Z M 51.152344 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 39.75 L 48.40625 40 Z M 47.910156 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 39.75 L 8.484375 40 Z M 7.984375 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 39.75 L 3.742188 40 Z M 3.242188 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 39.75 L 0.5 40 Z M 0 39.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 39.5 L 130 39.75 Z M 129.503906 39.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 39.5 L 50.152344 39.75 Z M 49.65625 39.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 39.5 L 2.246094 39.75 Z M 1.746094 39.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 35.25 L 125.261719 35.5 Z M 124.761719 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 35.25 L 117.277344 35.5 Z M 116.777344 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.851562 35.25 L 77.351562 35.5 Z M 76.851562 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 68.867188 35.25 L 69.367188 35.5 Z M 68.867188 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 60.882812 35.25 L 61.382812 35.5 Z M 60.882812 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 52.898438 35.25 L 53.398438 35.5 Z M 52.898438 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 35.25 L 13.472656 35.5 Z M 12.976562 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 35.25 L 5.488281 35.5 Z M 4.992188 35.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 33.75 L 130.75 34 Z M 130.25 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 33.75 L 122.765625 34 Z M 122.265625 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 74.359375 33.75 L 74.855469 34 Z M 74.359375 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 33.75 L 66.871094 34 Z M 66.375 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 58.386719 33.75 L 58.886719 34 Z M 58.386719 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 33.75 L 10.980469 34 Z M 10.480469 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 33.75 L 2.996094 34 Z M 2.496094 33.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 32.25 L 126.757812 32.5 Z M 126.257812 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 32.25 L 118.773438 32.5 Z M 118.273438 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 32.25 L 70.863281 32.5 Z M 70.367188 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.382812 32.25 L 62.878906 32.5 Z M 62.382812 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.394531 32.25 L 54.894531 32.5 Z M 54.394531 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 32.25 L 14.972656 32.5 Z M 14.472656 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 32.25 L 6.988281 32.5 Z M 6.488281 32.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 32 L 129.253906 32.25 Z M 128.753906 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 32 L 121.269531 32.25 Z M 120.769531 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72.859375 32 L 73.359375 32.25 Z M 72.859375 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 64.875 32 L 65.375 32.25 Z M 64.875 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 32 L 57.390625 32.25 Z M 56.890625 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 32 L 9.480469 32.25 Z M 8.984375 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 32 L 1.496094 32.25 Z M 1 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 31.75 L 128.253906 32 Z M 127.757812 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 31.75 L 123.515625 32 Z M 123.015625 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 31.75 L 120.269531 32 Z M 119.769531 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 31.75 L 75.605469 32 Z M 75.105469 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 71.863281 31.75 L 72.363281 32 Z M 71.863281 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 31.75 L 67.621094 32 Z M 67.121094 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 63.878906 31.75 L 64.378906 32 Z M 63.878906 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 31.75 L 59.636719 32 Z M 59.136719 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.894531 31.75 L 56.390625 32 Z M 55.894531 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 31.75 L 11.726562 32 Z M 11.230469 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 31.75 L 8.484375 32 Z M 7.984375 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 31.75 L 3.742188 32 Z M 3.242188 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 31.75 L 0.5 32 Z M 0 31.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 31.5 L 130 31.75 Z M 129.503906 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 31.5 L 122.015625 31.75 Z M 121.519531 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 73.609375 31.5 L 74.109375 31.75 Z M 73.609375 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.625 31.5 L 66.125 31.75 Z M 65.625 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.640625 31.5 L 58.140625 31.75 Z M 57.640625 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 31.5 L 10.230469 31.75 Z M 9.730469 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 31.5 L 2.246094 31.75 Z M 1.746094 31.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 27.25 L 125.261719 27.5 Z M 124.761719 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 27.25 L 117.277344 27.5 Z M 116.777344 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.808594 27.25 L 101.308594 27.5 Z M 100.808594 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.824219 27.25 L 93.320312 27.5 Z M 92.824219 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.929688 27.25 L 37.429688 27.5 Z M 36.929688 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 27.25 L 21.460938 27.5 Z M 20.960938 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 27.25 L 13.472656 27.5 Z M 12.976562 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 27.25 L 5.488281 27.5 Z M 4.992188 27.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 25.75 L 130.75 26 Z M 130.25 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 25.75 L 122.765625 26 Z M 122.265625 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 25.75 L 114.78125 26 Z M 114.28125 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 25.75 L 98.8125 26 Z M 98.3125 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 25.75 L 90.828125 26 Z M 90.328125 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 25.75 L 82.84375 26 Z M 82.34375 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 74.359375 25.75 L 74.855469 26 Z M 74.359375 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 25.75 L 66.871094 26 Z M 66.375 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 58.386719 25.75 L 58.886719 26 Z M 58.386719 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 25.75 L 50.902344 26 Z M 50.402344 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 25.75 L 42.917969 26 Z M 42.417969 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 25.75 L 34.933594 26 Z M 34.433594 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 25.75 L 18.964844 26 Z M 18.464844 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 25.75 L 10.980469 26 Z M 10.480469 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 25.75 L 2.996094 26 Z M 2.496094 25.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 24.25 L 126.757812 24.5 Z M 126.257812 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 24.25 L 118.773438 24.5 Z M 118.273438 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 24.25 L 102.804688 24.5 Z M 102.304688 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 24.25 L 94.820312 24.5 Z M 94.320312 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 24.25 L 86.835938 24.5 Z M 86.335938 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 24.25 L 46.910156 24.5 Z M 46.410156 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 24.25 L 38.925781 24.5 Z M 38.425781 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 24.25 L 30.941406 24.5 Z M 30.441406 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 24.25 L 14.972656 24.5 Z M 14.472656 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 24.25 L 6.988281 24.5 Z M 6.488281 24.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 24 L 129.253906 24.25 Z M 128.753906 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 24 L 121.269531 24.25 Z M 120.769531 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 24 L 113.285156 24.25 Z M 112.785156 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 24 L 97.3125 24.25 Z M 96.816406 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 24 L 89.328125 24.25 Z M 88.832031 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 24 L 81.34375 24.25 Z M 80.847656 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 24 L 49.40625 24.25 Z M 48.90625 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 24 L 41.421875 24.25 Z M 40.921875 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 24 L 33.4375 24.25 Z M 32.9375 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 24 L 17.464844 24.25 Z M 16.96875 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 24 L 9.480469 24.25 Z M 8.984375 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 24 L 1.496094 24.25 Z M 1 24 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 23.75 L 128.253906 24 Z M 127.757812 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 23.75 L 123.515625 24 Z M 123.015625 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 23.75 L 120.269531 24 Z M 119.769531 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 23.75 L 115.53125 24 Z M 115.03125 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 23.75 L 112.285156 24 Z M 111.785156 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 23.75 L 99.558594 24 Z M 99.0625 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 95.816406 23.75 L 96.316406 24 Z M 95.816406 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 23.75 L 91.574219 24 Z M 91.078125 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 87.832031 23.75 L 88.332031 24 Z M 87.832031 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 23.75 L 83.589844 24 Z M 83.089844 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 23.75 L 48.40625 24 Z M 47.910156 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 23.75 L 43.667969 24 Z M 43.167969 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.921875 23.75 L 40.421875 24 Z M 39.921875 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 23.75 L 35.683594 24 Z M 35.183594 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.9375 23.75 L 32.4375 24 Z M 31.9375 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 23.75 L 19.710938 24 Z M 19.214844 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 23.75 L 16.46875 24 Z M 15.96875 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 23.75 L 11.726562 24 Z M 11.230469 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 23.75 L 8.484375 24 Z M 7.984375 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 23.75 L 3.742188 24 Z M 3.242188 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 23.75 L 0.5 24 Z M 0 23.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 23.5 L 130 23.75 Z M 129.503906 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 23.5 L 122.015625 23.75 Z M 121.519531 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 23.5 L 114.03125 23.75 Z M 113.535156 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5625 23.5 L 98.0625 23.75 Z M 97.5625 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 89.578125 23.5 L 90.078125 23.75 Z M 89.578125 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 23.5 L 82.09375 23.75 Z M 81.59375 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 23.5 L 50.152344 23.75 Z M 49.65625 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.671875 23.5 L 42.167969 23.75 Z M 41.671875 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.6875 23.5 L 34.183594 23.75 Z M 33.6875 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 23.5 L 18.214844 23.75 Z M 17.714844 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 23.5 L 10.230469 23.75 Z M 9.730469 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 23.5 L 2.246094 23.75 Z M 1.746094 23.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 19.25 L 125.261719 19.5 Z M 124.761719 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 19.25 L 117.277344 19.5 Z M 116.777344 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.808594 19.25 L 101.308594 19.5 Z M 100.808594 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.824219 19.25 L 93.320312 19.5 Z M 92.824219 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.839844 19.25 L 85.335938 19.5 Z M 84.839844 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.851562 19.25 L 77.351562 19.5 Z M 76.851562 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 52.898438 19.25 L 53.398438 19.5 Z M 52.898438 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.914062 19.25 L 45.414062 19.5 Z M 44.914062 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.929688 19.25 L 37.429688 19.5 Z M 36.929688 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 19.25 L 21.460938 19.5 Z M 20.960938 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 19.25 L 13.472656 19.5 Z M 12.976562 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 19.25 L 5.488281 19.5 Z M 4.992188 19.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 17.75 L 130.75 18 Z M 130.25 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 17.75 L 122.765625 18 Z M 122.265625 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 17.75 L 114.78125 18 Z M 114.28125 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 17.75 L 98.8125 18 Z M 98.3125 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 17.75 L 90.828125 18 Z M 90.328125 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 17.75 L 82.84375 18 Z M 82.34375 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 74.359375 17.75 L 74.855469 18 Z M 74.359375 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 17.75 L 66.871094 18 Z M 66.375 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 58.386719 17.75 L 58.886719 18 Z M 58.386719 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 17.75 L 50.902344 18 Z M 50.402344 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 17.75 L 42.917969 18 Z M 42.417969 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 17.75 L 34.933594 18 Z M 34.433594 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 17.75 L 18.964844 18 Z M 18.464844 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 17.75 L 10.980469 18 Z M 10.480469 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 17.75 L 2.996094 18 Z M 2.496094 17.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 16.25 L 126.757812 16.5 Z M 126.257812 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 16.25 L 118.773438 16.5 Z M 118.273438 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 16.25 L 102.804688 16.5 Z M 102.304688 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 16.25 L 94.820312 16.5 Z M 94.320312 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 16.25 L 86.835938 16.5 Z M 86.335938 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 16.25 L 78.847656 16.5 Z M 78.351562 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 16.25 L 70.863281 16.5 Z M 70.367188 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.382812 16.25 L 62.878906 16.5 Z M 62.382812 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.394531 16.25 L 54.894531 16.5 Z M 54.394531 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 16.25 L 46.910156 16.5 Z M 46.410156 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 16.25 L 38.925781 16.5 Z M 38.425781 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 16.25 L 30.941406 16.5 Z M 30.441406 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 16.25 L 14.972656 16.5 Z M 14.472656 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 16.25 L 6.988281 16.5 Z M 6.488281 16.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 16 L 129.253906 16.25 Z M 128.753906 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 16 L 121.269531 16.25 Z M 120.769531 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 16 L 113.285156 16.25 Z M 112.785156 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 16 L 97.3125 16.25 Z M 96.816406 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 16 L 89.328125 16.25 Z M 88.832031 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 16 L 81.34375 16.25 Z M 80.847656 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72.859375 16 L 73.359375 16.25 Z M 72.859375 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 64.875 16 L 65.375 16.25 Z M 64.875 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 16 L 57.390625 16.25 Z M 56.890625 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 16 L 49.40625 16.25 Z M 48.90625 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 16 L 41.421875 16.25 Z M 40.921875 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 16 L 33.4375 16.25 Z M 32.9375 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 16 L 17.464844 16.25 Z M 16.96875 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 16 L 9.480469 16.25 Z M 8.984375 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 16 L 1.496094 16.25 Z M 1 16 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 15.75 L 128.253906 16 Z M 127.757812 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 15.75 L 123.515625 16 Z M 123.015625 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 15.75 L 120.269531 16 Z M 119.769531 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 15.75 L 115.53125 16 Z M 115.03125 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 15.75 L 112.285156 16 Z M 111.785156 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.0625 15.75 L 99.558594 16 Z M 99.0625 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 95.816406 15.75 L 96.316406 16 Z M 95.816406 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 91.078125 15.75 L 91.574219 16 Z M 91.078125 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 87.832031 15.75 L 88.332031 16 Z M 87.832031 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 83.089844 15.75 L 83.589844 16 Z M 83.089844 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 79.847656 15.75 L 80.347656 16 Z M 79.847656 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 75.105469 15.75 L 75.605469 16 Z M 75.105469 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 71.863281 15.75 L 72.363281 16 Z M 71.863281 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 67.121094 15.75 L 67.621094 16 Z M 67.121094 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 63.878906 15.75 L 64.378906 16 Z M 63.878906 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 59.136719 15.75 L 59.636719 16 Z M 59.136719 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 55.894531 15.75 L 56.390625 16 Z M 55.894531 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 51.152344 15.75 L 51.652344 16 Z M 51.152344 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.910156 15.75 L 48.40625 16 Z M 47.910156 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 43.167969 15.75 L 43.667969 16 Z M 43.167969 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.921875 15.75 L 40.421875 16 Z M 39.921875 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 35.183594 15.75 L 35.683594 16 Z M 35.183594 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 31.9375 15.75 L 32.4375 16 Z M 31.9375 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 15.75 L 19.710938 16 Z M 19.214844 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 15.75 L 16.46875 16 Z M 15.96875 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 15.75 L 11.726562 16 Z M 11.230469 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 15.75 L 8.484375 16 Z M 7.984375 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 15.75 L 3.742188 16 Z M 3.242188 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 15.75 L 0.5 16 Z M 0 15.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 15.5 L 130 15.75 Z M 129.503906 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 15.5 L 122.015625 15.75 Z M 121.519531 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 15.5 L 114.03125 15.75 Z M 113.535156 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 97.5625 15.5 L 98.0625 15.75 Z M 97.5625 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 89.578125 15.5 L 90.078125 15.75 Z M 89.578125 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 81.59375 15.5 L 82.09375 15.75 Z M 81.59375 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 73.609375 15.5 L 74.109375 15.75 Z M 73.609375 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 65.625 15.5 L 66.125 15.75 Z M 65.625 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.640625 15.5 L 58.140625 15.75 Z M 57.640625 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.65625 15.5 L 50.152344 15.75 Z M 49.65625 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 41.671875 15.5 L 42.167969 15.75 Z M 41.671875 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 33.6875 15.5 L 34.183594 15.75 Z M 33.6875 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 15.5 L 18.214844 15.75 Z M 17.714844 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 15.5 L 10.230469 15.75 Z M 9.730469 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 15.5 L 2.246094 15.75 Z M 1.746094 15.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 11.25 L 125.261719 11.5 Z M 124.761719 11.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 11.25 L 117.277344 11.5 Z M 116.777344 11.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 11.25 L 21.460938 11.5 Z M 20.960938 11.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 11.25 L 13.472656 11.5 Z M 12.976562 11.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 11.25 L 5.488281 11.5 Z M 4.992188 11.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 9.75 L 130.75 10 Z M 130.25 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 9.75 L 122.765625 10 Z M 122.265625 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 9.75 L 114.78125 10 Z M 114.28125 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 9.75 L 18.964844 10 Z M 18.464844 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 9.75 L 10.980469 10 Z M 10.480469 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 9.75 L 2.996094 10 Z M 2.496094 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 8.25 L 126.757812 8.5 Z M 126.257812 8.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 8.25 L 118.773438 8.5 Z M 118.273438 8.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 8.25 L 14.972656 8.5 Z M 14.472656 8.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 8.25 L 6.988281 8.5 Z M 6.488281 8.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 8 L 129.253906 8.25 Z M 128.753906 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 8 L 121.269531 8.25 Z M 120.769531 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 8 L 113.285156 8.25 Z M 112.785156 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 8 L 17.464844 8.25 Z M 16.96875 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 8 L 9.480469 8.25 Z M 8.984375 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 8 L 1.496094 8.25 Z M 1 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 127.757812 7.75 L 128.253906 8 Z M 127.757812 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 123.015625 7.75 L 123.515625 8 Z M 123.015625 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 119.769531 7.75 L 120.269531 8 Z M 119.769531 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 115.03125 7.75 L 115.53125 8 Z M 115.03125 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 111.785156 7.75 L 112.285156 8 Z M 111.785156 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 19.214844 7.75 L 19.710938 8 Z M 19.214844 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.96875 7.75 L 16.46875 8 Z M 15.96875 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.230469 7.75 L 11.726562 8 Z M 11.230469 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.984375 7.75 L 8.484375 8 Z M 7.984375 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.242188 7.75 L 3.742188 8 Z M 3.242188 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0 7.75 L 0.5 8 Z M 0 7.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 129.503906 7.5 L 130 7.75 Z M 129.503906 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 121.519531 7.5 L 122.015625 7.75 Z M 121.519531 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 113.535156 7.5 L 114.03125 7.75 Z M 113.535156 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.714844 7.5 L 18.214844 7.75 Z M 17.714844 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9.730469 7.5 L 10.230469 7.75 Z M 9.730469 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.746094 7.5 L 2.246094 7.75 Z M 1.746094 7.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.761719 3.25 L 125.261719 3.5 Z M 124.761719 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 116.777344 3.25 L 117.277344 3.5 Z M 116.777344 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 108.792969 3.25 L 109.292969 3.5 Z M 108.792969 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 100.808594 3.25 L 101.308594 3.5 Z M 100.808594 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 92.824219 3.25 L 93.320312 3.5 Z M 92.824219 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 84.839844 3.25 L 85.335938 3.5 Z M 84.839844 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 76.851562 3.25 L 77.351562 3.5 Z M 76.851562 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 68.867188 3.25 L 69.367188 3.5 Z M 68.867188 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 60.882812 3.25 L 61.382812 3.5 Z M 60.882812 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 52.898438 3.25 L 53.398438 3.5 Z M 52.898438 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 44.914062 3.25 L 45.414062 3.5 Z M 44.914062 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 36.929688 3.25 L 37.429688 3.5 Z M 36.929688 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 28.945312 3.25 L 29.445312 3.5 Z M 28.945312 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 20.960938 3.25 L 21.460938 3.5 Z M 20.960938 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 12.976562 3.25 L 13.472656 3.5 Z M 12.976562 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.992188 3.25 L 5.488281 3.5 Z M 4.992188 3.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 130.25 1.75 L 130.75 2 Z M 130.25 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 122.265625 1.75 L 122.765625 2 Z M 122.265625 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 114.28125 1.75 L 114.78125 2 Z M 114.28125 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 106.296875 1.75 L 106.796875 2 Z M 106.296875 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 98.3125 1.75 L 98.8125 2 Z M 98.3125 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 90.328125 1.75 L 90.828125 2 Z M 90.328125 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 82.34375 1.75 L 82.84375 2 Z M 82.34375 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 74.359375 1.75 L 74.855469 2 Z M 74.359375 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 66.375 1.75 L 66.871094 2 Z M 66.375 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 58.386719 1.75 L 58.886719 2 Z M 58.386719 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 50.402344 1.75 L 50.902344 2 Z M 50.402344 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 42.417969 1.75 L 42.917969 2 Z M 42.417969 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 34.433594 1.75 L 34.933594 2 Z M 34.433594 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.449219 1.75 L 26.949219 2 Z M 26.449219 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.464844 1.75 L 18.964844 2 Z M 18.464844 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 10.480469 1.75 L 10.980469 2 Z M 10.480469 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.496094 1.75 L 2.996094 2 Z M 2.496094 1.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 126.257812 0.25 L 126.757812 0.5 Z M 126.257812 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 118.273438 0.25 L 118.773438 0.5 Z M 118.273438 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 110.289062 0.25 L 110.789062 0.5 Z M 110.289062 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 102.304688 0.25 L 102.804688 0.5 Z M 102.304688 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 94.320312 0.25 L 94.820312 0.5 Z M 94.320312 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 86.335938 0.25 L 86.835938 0.5 Z M 86.335938 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 78.351562 0.25 L 78.847656 0.5 Z M 78.351562 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 70.367188 0.25 L 70.863281 0.5 Z M 70.367188 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 62.382812 0.25 L 62.878906 0.5 Z M 62.382812 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 54.394531 0.25 L 54.894531 0.5 Z M 54.394531 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 46.410156 0.25 L 46.910156 0.5 Z M 46.410156 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.425781 0.25 L 38.925781 0.5 Z M 38.425781 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 30.441406 0.25 L 30.941406 0.5 Z M 30.441406 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 22.457031 0.25 L 22.957031 0.5 Z M 22.457031 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.472656 0.25 L 14.972656 0.5 Z M 14.472656 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.488281 0.25 L 6.988281 0.5 Z M 6.488281 0.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 128.753906 0 L 129.253906 0.25 Z M 128.753906 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 120.769531 0 L 121.269531 0.25 Z M 120.769531 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 112.785156 0 L 113.285156 0.25 Z M 112.785156 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 104.800781 0 L 105.300781 0.25 Z M 104.800781 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.816406 0 L 97.3125 0.25 Z M 96.816406 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 88.832031 0 L 89.328125 0.25 Z M 88.832031 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.847656 0 L 81.34375 0.25 Z M 80.847656 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 72.859375 0 L 73.359375 0.25 Z M 72.859375 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 64.875 0 L 65.375 0.25 Z M 64.875 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 56.890625 0 L 57.390625 0.25 Z M 56.890625 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 48.90625 0 L 49.40625 0.25 Z M 48.90625 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 40.921875 0 L 41.421875 0.25 Z M 40.921875 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 32.9375 0 L 33.4375 0.25 Z M 32.9375 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 24.953125 0 L 25.453125 0.25 Z M 24.953125 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.96875 0 L 17.464844 0.25 Z M 16.96875 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.984375 0 L 9.480469 0.25 Z M 8.984375 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1 0 L 1.496094 0.25 Z M 1 0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolLogo);
export default __webpack_public_path__ + "static/media/symbol-logo.888cb92424d7f670e69e0f1b53a159c1.svg";
export { ForwardRef as ReactComponent };